import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AppRoutes } from '@shared/constants/routes.enum';
import { resolveLandingRoute } from '../../domain/utils/landing-route.util';
import { AuthStore } from '../store/auth.store';

export const authGuard: CanActivateFn = () => {
  const store = inject(AuthStore);
  return store.isAuthenticated() ? true : inject(Router).createUrlTree([AppRoutes.Login]);
};

export const guestGuard: CanActivateFn = () => {
  const store = inject(AuthStore);
  if (!store.isAuthenticated()) return true;

  const role = store.user()?.role ?? null;
  const hasCompletedOnboarding = store.user()?.hasCompletedOnboarding ?? true;
  const needsClinicSelection = (store.user()?.staffClinics?.length ?? 0) > 1;
  return inject(Router).createUrlTree([resolveLandingRoute(role, hasCompletedOnboarding, needsClinicSelection, store.user()?.accountRealm)]);
};

